export enum RowIdentificationKey {
	securityHolders = 'securityHolders',
	securityTypeSummarizedHolders = 'securityTypeSummarizedHolders',
	issuerSummarizedHolders = 'issuerSummarizedHolders',
	issuersHoldings = 'issuersHoldings',
}
